import { render, staticRenderFns } from "./MobileResponsiveShell.vue?vue&type=template&id=76524285&scoped=true"
import script from "./MobileResponsiveShell.vue?vue&type=script&lang=js"
export * from "./MobileResponsiveShell.vue?vue&type=script&lang=js"
import style0 from "./MobileResponsiveShell.vue?vue&type=style&index=0&id=76524285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76524285",
  null
  
)

export default component.exports